import * as React from "react";
const SvgFiRrFaceRelieved = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-relieved_svg__a)">
      <path
        fill="#062147"
        d="M18.655 10.244c.417.361.462.993.1 1.411-.728.841-1.776 1.342-2.806 1.342h-.02c-.71-.005-1.755-.242-2.693-1.352a1 1 0 1 1 1.528-1.291c.358.424.755.64 1.179.643h.007c.45 0 .946-.25 1.294-.652a1 1 0 0 1 1.41-.101M7.949 12.997c1.03 0 2.078-.501 2.807-1.342a1.001 1.001 0 0 0-1.512-1.31c-.35.402-.844.652-1.294.652h-.007c-.424-.003-.82-.219-1.18-.643a1 1 0 0 0-1.527 1.291c.938 1.109 1.983 1.347 2.694 1.352zm8.387 2.256C16.316 15.27 14.33 17 12 17c-2.314 0-4.287-1.705-4.335-1.747a1 1 0 0 0-1.331 1.493C6.437 16.838 8.893 19 12 19s5.563-2.162 5.666-2.254a.999.999 0 0 0-1.33-1.493M23.97 12c0 6.617-5.383 12-12 12s-12-5.383-12-12 5.383-12 12-12 12 5.383 12 12m-2 0c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10m-16-3a1 1 0 0 0 .783-.377c.625-.784 1.629-1.463 2.44-1.648a1 1 0 0 0 .752-1.197.996.996 0 0 0-1.198-.752c-1.252.286-2.65 1.209-3.56 2.352a1 1 0 0 0 .783 1.623zm8.777-2.025c.812.186 1.816.864 2.44 1.648a1 1 0 0 0 1.407.159 1 1 0 0 0 .159-1.405c-.91-1.143-2.307-2.065-3.56-2.352a1 1 0 0 0-1.197.752 1 1 0 0 0 .75 1.198"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-relieved_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceRelieved;
